import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js/instance/index-of";
import _lastIndexOfInstanceProperty from "@babel/runtime-corejs3/core-js/instance/last-index-of";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _Array$from from "@babel/runtime-corejs3/core-js/array/from";
import _Number$parseInt from "@babel/runtime-corejs3/core-js/number/parse-int";
import _keysInstanceProperty from "@babel/runtime-corejs3/core-js/instance/keys";
import _parseFloat from "@babel/runtime-corejs3/core-js/parse-float";
import _Number$EPSILON from "@babel/runtime-corejs3/core-js/number/epsilon";
import tinycolor from "tinycolor2";
import { KEYS_TO_SANITIZE, PREDEFINED_PAYMENT_PLANS, S3_BUCKET_URL, SUPPORTED_BROWSERS } from "../constants";
import Amplitude from "@Shared/utils/amplitude";
import UserMalePlaceHolderAsset from "@Shared/@Assets/img/user-male-placeholder.png";
import { javascriptFilePathRegex, VALID_APPLICATION_SUB_TABS } from "@Shared/js/constants";
import i18n from "@Shared/@i18n";
import { getApplicantName } from "../helpers/application";
import { cloneDeep, cloneDeepWith, every, forOwn, get, isArray, isEmpty, isEqual, isNull, isObject, isString, isUndefined, merge, pull, snakeCase, startCase, toLower, transform, trim, isNaN, upperFirst, capitalize, lowerCase } from "lodash";
import DOMPurify from "dompurify";
const keysToRemove = ["applicantIndex", "propertyIndex", "saving", "locked", "read", "updatedAt", "linkedProfiles", "appOwnerDetails", "groupSetVisible", "accountDetails", "loading", "shared", "sync", "syncable", "cobrokeredMortgages"];
const keysToIgnore = ["applicant-submission-exclusion"];
export const removeEmptyKeys = obj => {
  return function prune(current) {
    forOwn(current, function (value, key) {
      if (!_includesInstanceProperty(keysToIgnore).call(keysToIgnore, key) && (isUndefined(value) || isNull(value) || isNaN(value) || _includesInstanceProperty(keysToRemove).call(keysToRemove, key) || isString(value) && isEmpty(value) || isObject(value) && isEmpty(prune(value)))) {
        delete current[key];
      }
    });
    if (isArray(current)) pull(current, undefined);
    return current;
  }(cloneDeep(obj));
};
export const onlyNumbers = (event, allowDot, allowSign) => {
  const VALID_KEYS = [8, 9, 13, 27, 37, 38, 39, 40];
  const VALID_SIGNS = ["-", "+"];
  const currentCode = $.getEventKeyCode(event);
  const currentKey = $.getEventKey(event);
  let regex;
  if (allowSign) {
    regex = allowDot ? /^[+-][0-9.]/ : /^[+-][0-9]/;
  } else {
    regex = allowDot ? /[0-9.]/ : /[0-9]/;
  }
  if (_includesInstanceProperty(VALID_KEYS).call(VALID_KEYS, currentCode) || _includesInstanceProperty(VALID_SIGNS).call(VALID_SIGNS, currentKey) || event.ctrlKey || event.altKey) return;
  if (!regex.test(currentKey)) {
    event.preventDefault();
  }
};
export const getOnlyNumbersReplaceRegex = (allowDot, allowSign) => {
  const numberRegex = allowDot ? "[^\\.\\d]" : "[^\\d]";
  const signRegex = allowSign ? "^[+-]" : "";
  const regexString = signRegex + numberRegex;
  return new RegExp(regexString, "g");
};
export const getFullNameWithSalutationFrom = (details = {
  salutation: "",
  "first-name": "",
  "last-name": ""
}) => {
  const {
    salutation,
    "first-name": firstName,
    "last-name": lastName
  } = details;
  if (isEmpty(details) || !firstName) return "";
  const salutationSentence = salutation ? `${startCase(toLower(salutation))}. ` : "";
  const fullName = `${firstName || ""} ${lastName || ""}`;
  return salutationSentence + fullName;
};
export const difference = (object, base) => {
  function changes(object, base) {
    return transform(object, function (result, value, key) {
      if (!isEqual(value, base[key])) {
        result[key] = isObject(value) && isObject(base[key]) ? changes(value, base[key]) : value;
      }
    });
  }
  return changes(object, base);
};
export const stringToHash = string => {
  let hash = 0;
  if (string.length == 0) return hash;
  for (let i = 0; i < string.length; i++) {
    const char = string.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash;
  }
  return hash;
};
export const arrayToJsonPath = array => {
  return _reduceInstanceProperty(array).call(array, (acc, curr) => {
    if (acc === "") {
      acc += curr;
    } else {
      acc += `[${curr}]`;
    }
    return acc;
  }, "");
};
export const semverRegex = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
export const stripHtmlTags = htmlString => {
  var _context;
  return _trimInstanceProperty(_context = htmlString.replace(/<\/?[^>]+(>|$)/g, " ").replace(/&nbsp;/g, " ").replace(/\s\s+/g, " ")).call(_context);
};
export const omitDeep = (collection, excludeKeys) => {
  const omitFn = value => {
    if (value && typeof value === "object") {
      excludeKeys.forEach(key => {
        delete value[key];
      });
    }
  };
  return cloneDeepWith(collection, omitFn);
};
export const cleanHTML = htmlString => {
  var _context2;
  return _trimInstanceProperty(_context2 = htmlString.replace(/<style(.|[\r\n])*<\/style>/g, "").replace(/(<([^>]+)>)/gi, "\n").replace(/(&([^;]+);)/gi, "").replace(/\n\s*\n/g, "\n")).call(_context2);
};
export const getArrayNextItem = (value, array, {
  cycle
} = {
  cycle: true
}) => {
  const collection = array != null ? array : [];
  const currentIndex = _indexOfInstanceProperty(collection).call(collection, value);
  if (currentIndex === -1) return value;
  const lastIndex = collection.length - 1;
  const nextIndex = cycle && currentIndex === lastIndex ? 0 : currentIndex + 1;
  if (!cycle && nextIndex >= lastIndex) return collection[lastIndex];
  return collection[nextIndex];
};
export const openFileDialog = (url, filename, options = {}) => {
  if (!url) throw new Error("cannotDownloadFile");
  const aTag = document.createElement("a");
  const defaultOptions = {
    newWindow: false
  };
  const allOptions = _objectSpread(_objectSpread({}, defaultOptions), options);
  const rawFileName = filename || url.substr(_lastIndexOfInstanceProperty(url).call(url, "/") + 1);
  aTag.href = url;
  if (allOptions.newWindow) aTag.target = "_blank";else aTag.download = unescape(rawFileName || "");
  document.body.appendChild(aTag);
  aTag.click();
  document.body.removeChild(aTag);
};
export const replaceSVGId = (svg, id) => {
  if (!id) return;
  svg = svg.attr("id", id);
};
export const replaceSVGClass = (svg, imgClass) => {
  if (!imgClass) return;
  svg = svg.attr("class", imgClass + " replaced-svg");
};
export const replaceSVG = (imagesSelector = "img") => {
  const allImages = $(imagesSelector);
  _filterInstanceProperty(allImages).call(allImages, (idx, element) => {
    var _element$src$match;
    return !!((_element$src$match = element.src.match(/.*\.svg$/)) != null && _element$src$match.length);
  }).each((idx, element) => {
    const img = $(element);
    const imgId = img.attr("id");
    const imgClass = img.attr("class");
    const imgURL = img.attr("src");
    $.get(imgURL, unsanitizedData => {
      const data = $(DOMPurify.sanitize(unsanitizedData[0].outerHTML));
      let svg = $(_findInstanceProperty(data).call(data, "svg"));
      replaceSVGId(svg, imgId);
      replaceSVGClass(svg, imgClass);
      svg = svg.removeAttr("xmlns:a");
      img.replaceWith(svg);
      svg.attr("preserveAspectRatio", "xMidYMid meet");
    }, "xml");
  });
};
const ignoredFromBrowserRecommendation = ["#/unsubscribe"];
export const checkBrowser = ({
  browser,
  portal
}) => {
  var _context3;
  const currentBrowser = navigator.sayswho;
  const name = currentBrowser.substr(0, _indexOfInstanceProperty(currentBrowser).call(currentBrowser, " "));
  const version = currentBrowser.replace(`${name} `, "");
  return _includesInstanceProperty(currentBrowser).call(currentBrowser, browser.name) && _parseInt(version) >= browser.version && _includesInstanceProperty(_context3 = browser.supportedOn).call(_context3, portal);
};
export const browserNotRecommended = () => {
  const currentHash = window.location.hash.split("?")[0];
  if (_includesInstanceProperty(ignoredFromBrowserRecommendation).call(ignoredFromBrowserRecommendation, currentHash)) return false;
  const currentBrowser = navigator.sayswho;
  return SUPPORTED_BROWSERS.some(browser => _includesInstanceProperty(currentBrowser).call(currentBrowser, browser.name) && !browser.recommended);
};
export const browserNotSupported = portal => {
  const currentHash = window.location.hash.split("?")[0];
  if (_includesInstanceProperty(ignoredFromBrowserRecommendation).call(ignoredFromBrowserRecommendation, currentHash)) return false;
  const isSupportedBrowser = _findInstanceProperty(SUPPORTED_BROWSERS).call(SUPPORTED_BROWSERS, browser => checkBrowser({
    browser,
    portal
  }));
  return !navigator.sayswho || !isSupportedBrowser;
};
export const getDefaultProfilePhoto = person => {
  var _id$match;
  const api = "https://ui-avatars.com/api/";
  const id = person.username || person.id;
  if (!id) return UserMalePlaceHolderAsset;
  const seed = ((_id$match = id.match(/\d/g)) == null ? void 0 : _id$match.join("")) || "";
  let color = Math.floor(Math.abs(Math.sin(_parseInt(seed)) * 16777215) % 16777215).toString(16);
  while (color.length < 6) {
    color = "0" + color;
  }
  const tinyColor = tinycolor(color);
  let isLight = tinyColor.isLight();
  while (isLight) {
    color = tinyColor.darken().toHex();
    isLight = tinyColor.isLight();
  }
  const name = `${person.givenName}+${person.familyName}`;
  return `${api}?name=${name}&background=${color}&color=fff&size=256`;
};
export const scrollTop = async (target = "html,body") => {
  return new _Promise(resolve => {
    $(target).animate({
      scrollTop: 0
    }, 500, () => {
      resolve(null);
    });
  });
};
export const scrollBottom = async (target = "html,body") => {
  return new _Promise(resolve => {
    $(target).animate({
      scrollTop: $(target).height()
    }, 500, () => {
      resolve(null);
    });
  });
};
export const delay = (t, v) => {
  return new _Promise(resolve => {
    setTimeout(resolve.bind(null, v), t);
  });
};
export const decodeToken = token => {
  try {
    return JSON.parse(atob(token.split(".")[1]));
  } catch (e) {
    Amplitude.logHandledError(e, {
      token
    }, "Invalid Token");
    return null;
  }
};
export const clearPreferencesBooleans = preferences => {
  const preferenceObject = cloneDeep(preferences);
  for (const section in preferenceObject) {
    var _context4;
    const preference = preferenceObject[section];
    preferenceObject[section] = _reduceInstanceProperty(_context4 = _Object$keys(preference)).call(_context4, (preferenceAcc, preferenceKey) => {
      var _context5;
      const preferenceSection = preference[preferenceKey];
      preferenceAcc[preferenceKey] = _reduceInstanceProperty(_context5 = _Object$keys(preferenceSection)).call(_context5, (acc, key) => {
        const preferenceSectionType = preferenceSection[key];
        acc[key] = preferenceSectionType === "true" || preferenceSectionType === true;
        return acc;
      }, {});
      return preferenceAcc;
    }, {});
  }
  return preferenceObject;
};
export const getStructure = source => {
  const isArray = Array.isArray(source);
  const topLevelSkeleton = isArray ? [] : {};
  for (const key in source) {
    if (source.hasOwnProperty(key)) {
      const valueType = typeof source[key];
      if (isArray && key === "0" || !isArray) {
        topLevelSkeleton[key] = valueType === "object" && source[key] !== null ? getStructure(source[key]) : "";
      }
    }
  }
  return topLevelSkeleton;
};
export const fillArrays = (emptyApplication, application) => {
  return function fill(currentEmptyObj, currentAppObj) {
    forOwn(currentAppObj, (_value, key) => {
      var _currentEmptyObj$key$, _currentEmptyObj$key;
      const value = (currentEmptyObj == null ? void 0 : currentEmptyObj[key]) || _value;
      if (isArray(value) && currentAppObj[key] && currentEmptyObj[key] && ((_currentEmptyObj$key$ = (_currentEmptyObj$key = currentEmptyObj[key]) == null ? void 0 : _currentEmptyObj$key.length) != null ? _currentEmptyObj$key$ : 0) < currentAppObj[key].length) {
        var _context6;
        currentEmptyObj[key] = _mapInstanceProperty(_context6 = currentAppObj[key]).call(_context6, () => cloneDeep(getStructure(value[0])));
      }
      if (isObject(value) && currentAppObj && currentAppObj[key] && currentEmptyObj) {
        fill(currentEmptyObj[key], currentAppObj[key]);
      }
    });
    return currentEmptyObj;
  }(cloneDeep(emptyApplication), application);
};
export const pollApiCall = async (apiCall, options = {
  timeout: 90000,
  retry: 5000
}) => {
  let {
    timeout = 90000
  } = options;
  const {
    retry = 5000
  } = options;
  let response;
  do {
    await delay(retry);
    timeout = timeout - retry;
    try {
      response = await apiCall();
      const result = await fetch(response.url);
      response = result.status === 200 ? response : null;
    } catch (e) {
      response = null;
    }
  } while (!response && timeout > 0);
  return response;
};
export const openPopoverWindow = (url, options = {}) => {
  var _context7;
  const defaultOptions = {
    height: 500,
    width: 500,
    left: 100,
    top: 100,
    resizable: "yes",
    scrollbars: "yes",
    toolbar: "yes",
    menubar: "no",
    location: "no",
    directories: "no",
    status: "yes"
  };
  const mergedOptions = merge(defaultOptions, options);
  const windowOptions = _mapInstanceProperty(_context7 = _Object$keys(mergedOptions)).call(_context7, key => `${key}=${mergedOptions[key]}`).join(",");
  return window.open(url, "popUpWindow", windowOptions);
};
export const highlight = async (target, options = {}) => {
  const defaultOptions = {
    bgColor: "var(--primary-3)",
    delay: 300
  };
  const opt = $.extend({}, defaultOptions, options);
  const currentStyle = target.attr("style") || "";
  target.attr("style", `background-color: ${opt.bgColor} !important`);
  target.addClass("highlight-animation");
  await delay(opt.delay);
  target.attr("style", "").attr("style", currentStyle);
  await delay(opt.delay);
  target.removeClass("highlight-animation");
};
export const backgroundColorFromIdentity = identity => {
  var _identity$match;
  if (!identity) return "@Shared/@Assets/img/user-male-placeholder.png";
  const seed = ((_identity$match = identity.match(/\d/g)) == null ? void 0 : _identity$match.join("")) || "";
  let color = Math.floor(Math.abs(Math.sin(_parseInt(seed)) * 16777215) % 16777215).toString(16);
  while (color.length < 6) {
    color = "0" + color;
  }
  const tinyColor = tinycolor(color);
  let isLight = tinyColor.isLight();
  while (isLight) {
    color = tinyColor.darken().toHex();
    isLight = tinyColor.isLight();
  }
  return `#${color}`;
};
export const getCurrentColor = () => {
  const bodyStyles = window.getComputedStyle(document.body);
  const primary = trim(bodyStyles.getPropertyValue("--primary"));
  const secondary = trim(bodyStyles.getPropertyValue("--secondary"));
  const primaryAlt = trim(bodyStyles.getPropertyValue("--primary-alt"));
  const primaryRGB = trim(bodyStyles.getPropertyValue("--primary-rgb"));
  const primaryClear = trim(bodyStyles.getPropertyValue("--primary-clear"));
  return {
    primary,
    secondary,
    primaryAlt,
    primaryRGB,
    primaryClear
  };
};
export const defaultAssignableColors = () => {
  const {
    primary,
    secondary
  } = getCurrentColor();
  return {
    red: "#ff0000",
    orange: "#ff7f00",
    yellow: "#ffff00",
    blue: "#0000ff",
    none: "#fff",
    cyan: "#00ffff",
    green: "#00ff7f",
    magenta: "#ff00ff",
    purple: "#7f00ff",
    black: "#111111",
    user: primary.toLowerCase(),
    userSecondary: secondary.toLowerCase()
  };
};
export const validSIN = sin => {
  var _context8;
  const SIN_MULT_PATTERN = [1, 2, 1, 2, 1, 2, 1, 2, 1];
  const sinArray = _Array$from(sin);
  if (sinArray.every(sin => !sin)) return true;
  const digits = _mapInstanceProperty(sinArray).call(sinArray, digit => _Number$parseInt(digit, 10));
  const sum = _reduceInstanceProperty(_context8 = _mapInstanceProperty(digits).call(digits, (dig, index) => {
    const prod = dig * SIN_MULT_PATTERN[index];
    return Math.floor(prod / 10) + prod % 10;
  })).call(_context8, (sum, dig) => {
    return sum + dig;
  }, 0);
  return sum % 10 === 0;
};
export const importAllNamed = (r, module = true, matchRegex = javascriptFilePathRegex) => {
  const modules = {};
  _keysInstanceProperty(r).call(r).forEach(key => {
    const matched = key.match(matchRegex);
    if (matched && matched.length > 1) {
      const moduleName = matched[1];
      modules[moduleName] = module ? r(key).default : r(key);
    }
  });
  return modules;
};
export const runApplicationTransformObject = (transformObjects = [], applicationObject = {}) => {
  if (isEmpty(transformObjects)) return applicationObject;
  return _reduceInstanceProperty(transformObjects).call(transformObjects, (acc, transformObject) => {
    if (typeof transformObject.transform !== "function") {
      Amplitude.logHandledError(new Error("Invalid Application Transform Function on addition"), {
        transformObjects
      });
      return acc;
    }
    acc = transformObject.transform(acc);
    return acc;
  }, cloneDeep(applicationObject));
};
export const getApplicationDefaultValueOnAddition = (values, applicationObject, defaultValuesSchema) => {
  const {
    where
  } = cloneDeep(values || {});
  const transformObjects = _filterInstanceProperty(defaultValuesSchema).call(defaultValuesSchema, ({
    paths,
    triggerOnAddition
  }) => triggerOnAddition && paths && _includesInstanceProperty(paths).call(paths, where.replace(/\[\d*?\]/g, "[X]").replace(/'/g, "")));
  Amplitude.logEvent("Application - default values loaded", {
    caller: "getApplicationDefaultValueOnAddition"
  });
  return runApplicationTransformObject(transformObjects, applicationObject);
};
export const getApplicationWithDefaults = (applicationObject, defaultValuesSchema) => {
  let transformedApplicationObject = cloneDeep(applicationObject);
  defaultValuesSchema.forEach(transformObject => {
    const {
      transform,
      triggerOnLoad
    } = transformObject;
    if (!triggerOnLoad) return;
    if (typeof transformObject.transform !== "function") {
      Amplitude.logHandledError(new Error("Invalid Application Transform Function"), {
        transformObject
      });
      return;
    }
    transformedApplicationObject = transform(transformedApplicationObject);
  });
  Amplitude.logEvent("Application - default values loaded", {
    caller: "getApplicationWithDefaults"
  });
  return transformedApplicationObject;
};
export const getApplicationWithDefaultsForPage = (page, applicationObject, defaultValuesSchema, options = {
  triggerOnSave: false
}) => {
  let transformedApplicationObject = cloneDeep(applicationObject);
  defaultValuesSchema.forEach(transformObject => {
    const {
      transform,
      rootPath,
      triggerOnSave
    } = transformObject;
    const transformNotForTriggerOnSave = options.triggerOnSave && !triggerOnSave;
    const transformNotForPage = page !== rootPath;
    if (transformNotForTriggerOnSave || transformNotForPage) return;
    if (typeof transformObject.transform !== "function") {
      Amplitude.logHandledError(new Error("Invalid Application Transform Function"), {
        transformObject
      });
      return;
    }
    transformedApplicationObject = transform(transformedApplicationObject);
  });
  Amplitude.logEvent("Application - default values loaded", {
    caller: "getApplicationWithDefaultsForPage"
  });
  return transformedApplicationObject;
};
export const jsonErrorReplacer = value => {
  if (value instanceof Error) {
    return _objectSpread(_objectSpread({}, value), {}, {
      name: value.name,
      message: value.message,
      stack: value.stack
    });
  }
  return value;
};
export const rgbToHsl = (r, g, b) => {
  const r1 = r / 255;
  const g1 = g / 255;
  const b1 = b / 255;
  const maxColor = Math.max(r1, g1, b1);
  const minColor = Math.min(r1, g1, b1);
  let L = (maxColor + minColor) / 2;
  let S = 0;
  let H = 0;
  if (maxColor != minColor) {
    if (L < 0.5) {
      S = (maxColor - minColor) / (maxColor + minColor);
    } else {
      S = (maxColor - minColor) / (2.0 - maxColor - minColor);
    }
    if (r1 == maxColor) {
      H = (g1 - b1) / (maxColor - minColor);
    } else if (g1 == maxColor) {
      H = 2.0 + (b1 - r1) / (maxColor - minColor);
    } else {
      H = 4.0 + (r1 - g1) / (maxColor - minColor);
    }
  }
  L = L * 100;
  S = S * 100;
  H = H * 60;
  if (H < 0) {
    H += 360;
  }
  return {
    h: Math.ceil(H),
    s: Math.ceil(S),
    l: Math.ceil(L)
  };
};
export const updateColours = (primary, secondary) => {
  const primaryColour = tinycolor(primary);
  const rgb = primaryColour.setAlpha(0.25).toString();
  const rgbClear = primaryColour.setAlpha(0.05).toString();
  const documentColours = {
    "--primary": primary,
    "--primary-alt": primary,
    "--primary-rgb": rgb,
    "--primary-clear": rgbClear,
    "--secondary": secondary
  };
  for (const key in documentColours) {
    document.documentElement.style.setProperty(key, documentColours[key]);
  }
  let idx = 1;
  for (let i = 95; i >= 50; i = i - 10) {
    const rgbObj = primaryColour.toRgb();
    const hsl = rgbToHsl(rgbObj.r, rgbObj.g, rgbObj.b);
    const value = `hsl(${hsl.h},${hsl.s}%,${i}%)`;
    document.documentElement.style.setProperty(`--primary-${idx}`, value);
    idx++;
    if (idx === 4 || idx === 5) i += 5;
  }
};
export const loadCSS = (filename, forceReload = false) => {
  let timestamp = "";
  const time = new Date().getTime();
  if (forceReload) timestamp = `?${time}`;
  const cssNode = document.createElement("link");
  cssNode.setAttribute("id", "custom-styles-stylesheet");
  cssNode.setAttribute("rel", "stylesheet");
  cssNode.setAttribute("type", "text/css");
  cssNode.setAttribute("href", `${S3_BUCKET_URL}/portal-styles/${filename}.css${timestamp}`);
  document.getElementsByTagName("head")[0].appendChild(cssNode);
  return cssNode;
};
export const getPlanDetails = plan => {
  var _context9;
  return _findInstanceProperty(_context9 = PREDEFINED_PAYMENT_PLANS()).call(_context9, ({
    name
  }) => name === plan);
};
export const toggleApplicationSchemeColumnAsRequired = (column, isRequired, flow) => {
  if (column) {
    if (!isRequired) {
      if (!isArray(column.validation)) {
        column.validation[flow].push("required");
      } else {
        column.validation.push("required");
      }
    } else {
      if (!isArray(column.validation)) {
        var _context0;
        column.validation[flow] = _filterInstanceProperty(_context0 = column.validation[flow]).call(_context0, validation => validation !== "required");
      } else {
        var _context1;
        column.validation = _filterInstanceProperty(_context1 = column.validation).call(_context1, validation => validation !== "required");
      }
    }
  }
  return column;
};
export const isApplicationSchemeColumnRequired = (column, flow) => {
  if (column) {
    if (!column.validation) {
      throw new Error(`Column [${column.key}] does NOT have a validation key`);
    }
    if (!isArray(column.validation)) {
      var _context10;
      return _includesInstanceProperty(_context10 = column.validation[flow]).call(_context10, "required");
    } else {
      var _context11;
      return _includesInstanceProperty(_context11 = column.validation).call(_context11, "required");
    }
  }
  return true;
};
export const formatApplicantsData = (applicants, getIdFunction, keysToReplace, includeCoApplicantText = false) => {
  return _mapInstanceProperty(applicants).call(applicants, applicant => {
    var _context12;
    const applicantName = `${getApplicantName(applicant.applicantIndex, applicant)}`;
    const mainApplicantText = i18n.t("application-form.main-applicant") !== applicantName && applicant.applicantIndex === 0 ? `(${i18n.t("application-form.main-applicant")})` : "";
    const coApplicantText = !_includesInstanceProperty(applicantName).call(applicantName, i18n.t("application-form.co-applicant").toString().toLowerCase()) && applicant.applicantIndex !== 0 && includeCoApplicantText ? `(${i18n.t("application-form.co-applicant")})` : "";
    const applicantText = applicant.applicantIndex === 0 ? mainApplicantText : coApplicantText;
    return _objectSpread(_objectSpread({}, applicant), {}, {
      id: getIdFunction(applicant),
      [keysToReplace.fullName]: _trimInstanceProperty(_context12 = `${applicantName} ${applicantText}`).call(_context12)
    });
  });
};
export const getRequestPackageBadgeType = status => {
  switch (status) {
    case "sent":
      return "bg-light-gray text-white";
    case "signed":
    case "completed":
      return "badge-success";
    case "awaiting_signature":
    case "pending":
      return "badge-warning";
    default:
      "badge-danger";
  }
};
export const isObjectWithEmptyProperties = obj => {
  const cleanedObj = removeEmptyKeys(obj);
  return every(cleanedObj, isEmpty);
};
export const snakeUppercase = word => {
  return snakeCase(word).toUpperCase();
};
export const calculateMortgageAmountValue = (propertyValue, downPaymentAmount, allOtherMortgagesAmount) => {
  const mortgageAmount = _parseFloat(propertyValue.toString()) - _parseFloat(downPaymentAmount.toString()) - _parseFloat(allOtherMortgagesAmount.toString());
  return mortgageAmount.toFixed(2);
};
export const clearSensitive = dirtyObject => {
  const sensitiveKeys = ["pass", "code", "token"];
  const replacer = (value, key) => {
    if (isArray(value)) return _mapInstanceProperty(value).call(value, obj => cloneDeepWith(obj, replacer));
    if (!isObject(value)) {
      try {
        const parsedObject = JSON.parse(value);
        return cloneDeepWith(parsedObject, replacer);
      } catch (_unused) {}
      if (sensitiveKeys.some(sensitiveKey => {
        var _context13;
        return key == null ? void 0 : _includesInstanceProperty(_context13 = key.toLowerCase()).call(_context13, sensitiveKey);
      })) {
        return "obfuscated";
      }
    }
  };
  return cloneDeepWith(dirtyObject, replacer);
};
export const getSubdomainFromURL = () => {
  return window.location.pathname.replace("/", "").replace("#", "");
};
export const getRouteMetaValue = (route, metaKeyPath) => {
  var _context14, _matchingRoute$meta$m;
  const matchingRoute = _findInstanceProperty(_context14 = route.matched).call(_context14, record => get(record.meta, metaKeyPath));
  return (_matchingRoute$meta$m = matchingRoute == null ? void 0 : matchingRoute.meta[metaKeyPath]) != null ? _matchingRoute$meta$m : false;
};
export const clearDeprecatedStorage = () => {
  const oldTokenStore = window.localStorage.getItem("store.body.session.token");
  if (oldTokenStore) {
    const localStorageKeys = _Object$keys(window.localStorage);
    localStorageKeys.forEach(localStorageKey => {
      if (_includesInstanceProperty(localStorageKey).call(localStorageKey, "store.body")) window.localStorage.removeItem(localStorageKey);
    });
  }
};
export const calculateFileSize = size => {
  return Math.round(size / (1024 * 1024) * 100) / 100;
};
export const customFieldsTypeDefinitions = {
  text: {
    key: "text",
    icon: "fa fa-text-height"
  },
  numeric: {
    key: "numeric",
    icon: "fa fa-hashtag"
  },
  monetary: {
    key: "monetary",
    icon: "fa fa-usd"
  },
  phone: {
    key: "phone",
    icon: "fa fa-phone"
  },
  date: {
    key: "date",
    icon: "fa fa-calendar custom-field-calendar text-primary"
  },
  address: {
    key: "address",
    icon: "fa fa-map-marker"
  },
  email: {
    key: "email",
    icon: "fa fa-envelope"
  },
  dropdown: {
    key: "dropdown",
    icon: "fa fa-caret-square-o-down"
  }
};
export const parseGenericLocale = localeString => {
  const localeMap = {
    en: "en-CA",
    fr: "fr-CA"
  };
  const validLocales = _Object$keys(localeMap);
  const detectedLocal = _findInstanceProperty(validLocales).call(validLocales, validLocale => _includesInstanceProperty(localeString).call(localeString, validLocale));
  return localeMap[detectedLocal] || "en-CA";
};
export const getFormattedScheduledTime = scheduledTime => {
  return /\d\d:\d\d:\d\d/.test(scheduledTime) ? scheduledTime : scheduledTime + ":00";
};
export const round = num => Math.round((num + _Number$EPSILON) * 100) / 100;
export const allowPropagationScroll = (event, target) => {
  const scrollUp = event.deltaY < 0;
  const {
    scrollTop,
    scrollHeight,
    clientHeight
  } = target;
  const top = scrollTop;
  const position = scrollHeight - clientHeight;
  const maximum = top / position;
  if (maximum === 0 && !scrollUp || maximum === 1 && scrollUp || maximum > 0 && maximum < 1) event.stopPropagation();
};
export const generateAddressLine1 = addressObject => {
  const {
    "street-number": streetNumber,
    "unit-number": unitNumber,
    "street-name": streetName
  } = addressObject;
  if (streetName === "" && unitNumber === "" && streetNumber === "") return;
  const newLine1 = `${unitNumber ? `${unitNumber}-` : ""}${streetNumber || ""} ${streetName || ""}`;
  return newLine1;
};
export const constructLine1 = (addressObject, oldAddressObject) => {
  const {
    "street-number": streetNumber,
    "unit-number": unitNumber,
    "street-name": streetName
  } = addressObject;
  const {
    "street-number": oldStreetNumber,
    "unit-number": oldUnitNumber,
    "street-name": oldStreetName
  } = oldAddressObject;
  if (streetNumber === oldStreetNumber && unitNumber === oldUnitNumber && streetName === oldStreetName) return;
  const newLine1 = `${unitNumber ? `${unitNumber}-` : ""}${streetNumber || ""} ${streetName || ""}`;
  return _objectSpread(_objectSpread({}, addressObject), {}, {
    line1: newLine1
  });
};
export const sanitizeInputs = (serialized, options = {
  startCase: false,
  upperFirst: false
}) => {
  for (const key in serialized) {
    if (_includesInstanceProperty(KEYS_TO_SANITIZE).call(KEYS_TO_SANITIZE, key)) {
      serialized[key] = trim(serialized[key]);
      if (key === "email") serialized[key] = toLower(serialized[key]);else if (options.upperFirst) {
        serialized[key] = upperFirst(serialized[key]);
      } else if (!options.startCase) {
        serialized[key] = capitalize(serialized[key]);
      } else {
        serialized[key] = startCase(lowerCase(serialized[key]));
      }
    }
  }
  return serialized;
};
export const isValidWithWarnings = validator => {
  const leafParams = validator.$flattenParams();
  return leafParams.every(({
    name,
    path
  }) => {
    var _validation$$params$n;
    const fullPath = path.join(".");
    const validation = get(validator, fullPath);
    const isSoftError = ((_validation$$params$n = validation.$params[name]) == null ? void 0 : _validation$$params$n.softError) || null;
    const valid = isSoftError !== null ? isSoftError : validation[name];
    return valid;
  });
};
export const extractApplicationRouteName = (tab, routeAppend = true) => {
  if (tab === "application") return "application";
  if (_includesInstanceProperty(VALID_APPLICATION_SUB_TABS).call(VALID_APPLICATION_SUB_TABS, tab)) return `${routeAppend ? "application-" : ""}${tab}`;
  return "";
};
export const clientProfileValueToNumber = clientProfileValue => {
  return typeof clientProfileValue === "number" ? clientProfileValue : +clientProfileValue || 0;
};
export const ignoreTransformWith = (obj, conditionFn) => transform(obj, (r, v, k) => {
  if (conditionFn(v)) return undefined;
  r[k] = isObject(v) ? ignoreTransformWith(v, conditionFn) : v;
});
export const validateApplicationPath = path => {
  const splitPath = path.match(/[\w-]+/gm) || [];
  return _reduceInstanceProperty(splitPath).call(splitPath, (acc, curr) => {
    if (curr) {
      acc += `[${curr}]`;
    }
    return acc;
  }, "").replace(/\[\d*?\]/g, "");
};
export const randomString = () => (Math.random() + 1).toString(36).substring(7);